import { useCallback, useRef } from "react";

//#region src/hooks/useStableCallback.ts
function useStableCallback(fn) {
	const fnRef = useRef(fn);
	fnRef.current = fn;
	const stableCallback = useCallback((...args) => fnRef.current?.(...args), []);
	return fn ? stableCallback : void 0;
}

//#endregion
export { useStableCallback };